import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { trackPromise } from 'react-promise-tracker';
import { useSnackBar } from '../../../../../hooks/snackBar';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel'
import DadosFinanceirosSeller from '../DadosFinanceiros'
import services from '../../../../../services'
import {
    cadastrarRemuneracaoSeller,
    editarRemuneracao,
    obterIdRemuneracaoSeller,
    detalheRemuneracaoSeller,
    inativarRemuneracaoSeller,
    ativarRemuneracaoSeller
} from '../../../../../services/http/SellerAdminstradorService/remuneracaoSellerService';

import CurrencyTextField from '@unicef/material-ui-currency-textfield';

import './styles.scss';
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const RemuneracaoSeller = ({ subSellerPage }) => {
    const [isFormInvalid, setIsFormInvalid] = useState(false);
    const [idRemuneracaoSeller, setIdRemuneracaoSeller] = useState(false);
    const { idEmpresa } = useParams();
    const { addSnackBar } = useSnackBar();
    const [remuneracao, setRemuneracao] = useState(
        {
            id: undefined,
            contratoEnviadoSeller: false,
            contratoAprovadoSeller: false,
            fee: null,
            status: "",
            setupIntegracao: null,
            comissao: null,
            dadosFinanceiros: [
                {
                    id: undefined,
                    dadosEmpresaSellerId: "",
                    banco: "",
                    agencia: "",
                    conta: "",
                    principal: false
                }
            ]
        });

    const adicionarConta = () => {
        remuneracao.dadosFinanceiros.push({
            dadosEmpresaSellerId: "",
            banco: "",
            agencia: "",
            conta: "",
            principal: false
        })

        setRemuneracao((prevent) => ({
            ...prevent,
            dadosFinanceiros: remuneracao.dadosFinanceiros
        }));
    }

    const changeRemueracaoObj = (value, propertie) => {
        setRemuneracao((prevent) => ({
            ...prevent,
            [propertie]: value
        }));
    }

    const obterDetalhesRemuneracaoSeller = (idRemuneracao) => {
        trackPromise(
            detalheRemuneracaoSeller(idRemuneracao, idEmpresa)
                .then(res => {
                    if (res.data != null && res.data != undefined) {
                        setRemuneracao(res.data);
                    } else {
                        addSnackBar({ message: 'Não foi possível recuperar remuneração seller', info: 'warning', open: true });
                        /* res.errors.forEach(element => {
                            addSnackBar({ message: element.menssagem, info: 'warning', open: true });  
                        }); */

                    }
                }).catch(error => {
                    console.log(error);
                    addSnackBar({ message: 'Erro ao recuperar remuneração seller', info: 'error', open: true });
                })
        )
    }


    const getIdRemuneracaoSeller = () => {
        trackPromise(
            obterIdRemuneracaoSeller(idEmpresa)
                .then(res => {
                    if (!res.fail) {
                        setIdRemuneracaoSeller(res.data);
                        obterDetalhesRemuneracaoSeller(res.data);
                    }
                }).catch(error => {
                    console.log(error);
                    addSnackBar({ message: 'Erro ao recuperar remuneração seller', info: 'error', open: true });
                })
        )
    }

    useEffect(() => {
        getIdRemuneracaoSeller();
    }, []);

    const validarForm = () => {
        var isInvalidForm = false;
        /*         if (!remuneracao?.fee) isInvalidForm = true; */
        if (!remuneracao?.setupIntegracao) isInvalidForm = true;
        if (!remuneracao?.comissao) isInvalidForm = true;
        if (remuneracao.dadosFinanceiros.length == 1) {
            if (remuneracao.dadosFinanceiros[0].conta === ""
                || remuneracao.dadosFinanceiros[0].agencia === ""
                || remuneracao.dadosFinanceiros[0].banco === ""
                || remuneracao.dadosFinanceiros[0].principal === false) {
                addSnackBar({ message: 'Informe ao menos uma conta principal', info: 'warning', open: true });
                isInvalidForm = true;
            }
        }
        setIsFormInvalid(isInvalidForm);

        return isInvalidForm;
    }

    const contaBancaria = (valor, propriedade, indexPosition) => {
        var jaPossuiPrincipal = false;
        if (propriedade === "principal") {
            remuneracao.dadosFinanceiros.map(dados => {
                if (dados.principal && valor === true) {
                    addSnackBar({ message: 'Você ja possui uma conta marcada como princial', info: 'info', open: true });
                    jaPossuiPrincipal = true;;
                }
            })
        }

        if (!jaPossuiPrincipal) {
            remuneracao.dadosFinanceiros[indexPosition][propriedade] = valor;
            remuneracao.dadosFinanceiros[indexPosition].dadosEmpresaSellerId = idEmpresa;

            changeRemueracaoObj(remuneracao.dadosFinanceiros, "dadosFinanceiros");
        }
    }

    const submitRemuneracao = () => {
        if (!validarForm()) {
            if (!idRemuneracaoSeller) {
                trackPromise(
                    cadastrarRemuneracaoSeller(idEmpresa, remuneracao)
                        .then(res => {
                            if (res.data) {
                                addSnackBar({ message: 'Cadastrado com sucesso', info: 'success', open: true });
                                subSellerPage(1);
                                obterDetalhesRemuneracaoSeller(idRemuneracaoSeller);
                            } else {
                                res.errors.forEach(element => {
                                    addSnackBar({ message: element.menssagem, info: 'warning', open: true });
                                });

                            }
                        }).catch(error => {
                            console.log(error);
                            addSnackBar({ message: 'Erro ao cadastrar remuneração seller', info: 'error', open: true });
                        })
                )
            } else {
                trackPromise(
                    editarRemuneracao(idEmpresa, remuneracao)
                        .then(res => {
                            if (res.data) {
                                addSnackBar({ message: 'Alterado com sucesso', info: 'success', open: true });
                                obterDetalhesRemuneracaoSeller(idRemuneracaoSeller);
                            } else {
                                /*  addSnackBar({ message: 'Não foi possível alterar remuneração seller', info: 'warning', open: true }); */
                                res.errors.forEach(element => {
                                    addSnackBar({ message: element.menssagem, info: 'warning', open: true });
                                });

                            }
                        }).catch(error => {
                            console.log(error);
                            addSnackBar({ message: 'Erro ao alterar remuneração seller', info: 'error', open: true });
                        })
                )
            }

        }
    }

    const inativarRemuneracao = () => {
        trackPromise(
            inativarRemuneracaoSeller(idRemuneracaoSeller)
                .then(res => {
                    if (res.data) {
                        addSnackBar({ message: 'Inativado com sucesso', info: 'success', open: true });
                        obterDetalhesRemuneracaoSeller(idRemuneracaoSeller);
                    } else {
                        addSnackBar({ message: 'Não foi possível inativar remuneração seller', info: 'warning', open: true });
                        /* res.errors.forEach(element => {
                            addSnackBar({ message: element.menssagem, info: 'warning', open: true });  
                        }); */

                    }
                }).catch(error => {
                    console.log(error);
                    addSnackBar({ message: 'Erro ao itativar remuneração seller', info: 'error', open: true });
                })
        )
    }

    const ativarRemuneracao = () => {
        trackPromise(
            ativarRemuneracaoSeller(idRemuneracaoSeller)
                .then(res => {
                    if (res.data) {
                        addSnackBar({ message: 'Ativado com sucesso', info: 'success', open: true });
                        obterDetalhesRemuneracaoSeller(idRemuneracaoSeller);
                    } else {
                        addSnackBar({ message: 'Não foi possível ativar remuneração seller', info: 'warning', open: true });
                        /* res.errors.forEach(element => {
                            addSnackBar({ message: element.menssagem, info: 'warning', open: true });  
                        }); */

                    }
                }).catch(error => {
                    console.log(error);
                    addSnackBar({ message: 'Erro ao ativar remuneração seller', info: 'error', open: true });
                })
        )
    }


    return (
        <div>
            <div className='row mt20 ml-1'>
                <h1 className='label-second'>Contrato Greeners</h1>
            </div>

            <div className='row mt20 ml-1'>
                <h1 className='label-second' style={{ fontSize: '20px' }}>Status: <strong style={{ color: 'black' }}>{remuneracao.status}</strong></h1>
            </div>

            <div className='row mt20'>
                <div className='col-md-3 col-sm-3 col-lg-3 ml-1'>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Contrato enviado para o Seller?</FormLabel>
                        <RadioGroup className="radio-notify" value={remuneracao.contratoEnviadoSeller ? "sim" : "nao"} row aria-label="notificacoes" name="row-radio-buttons-group">
                            <FormControlLabel onChange={() => changeRemueracaoObj(true, 'contratoEnviadoSeller')} value={remuneracao.contratoEnviadoSeller ? "sim" : "sim"} control={<Radio />} label="Sim" />
                            <FormControlLabel onChange={() => changeRemueracaoObj(false, 'contratoEnviadoSeller')} value={!remuneracao.contratoEnviadoSeller ? "nao" : "nao"} control={<Radio />} label="Não" />
                        </RadioGroup>
                    </FormControl>
                </div>
                <div className='col-md-3 col-sm-3 col-lg-3 ml-1'>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Contrato aprovado pelo Seller?</FormLabel>
                        <RadioGroup className="radio-notify" value={remuneracao.contratoAprovadoSeller ? "sim" : "nao"} row aria-label="notificacoes" name="row-radio-buttons-group">
                            <FormControlLabel onChange={() => changeRemueracaoObj(true, 'contratoAprovadoSeller')} value={remuneracao.contratoAprovadoSeller ? "sim" : "sim"} control={<Radio />} label="Sim" />
                            <FormControlLabel onChange={() => changeRemueracaoObj(false, 'contratoAprovadoSeller')} value={!remuneracao.contratoAprovadoSeller ? "nao" : "nao"} control={<Radio />} label="Não" />
                        </RadioGroup>
                    </FormControl>
                </div>
            </div>
            <div className='row mt20 ml-1'>
                <h1 className='label-second'>Remuneração Greeners</h1>
            </div>
            <div className="row mt20">
                <div className='col-md-4 col-sm-4 col-lg-4'>
                    <FormControl >
                        <CurrencyTextField
                            fullWidth
                            id="standard-bare"
                            variant="outlined"
                            label="Fee"
                            size="small"
                            currencySymbol="R$"
                            decimalCharacter=","
                            digitGroupSeparator="."
                            onChange={(event, value) => changeRemueracaoObj(value, 'fee')}
                            value={services.mask.number(remuneracao.fee) || "0"}
                            helperText={isFormInvalid && !remuneracao?.fee && 'Campo obrigatório'}
                            error={isFormInvalid && !remuneracao?.fee ? true : false} />
                    </FormControl>
                </div>
                <div className='col-md-4 col-sm-4 col-lg-4'>
                    <FormControl >
                        <CurrencyTextField
                            fullWidth
                            id="standard-bare"
                            variant="outlined"
                            label="Setup Integração"
                            size="small"
                            currencySymbol="R$"
                            decimalCharacter=","
                            digitGroupSeparator="."
                            onChange={(event, value) => changeRemueracaoObj(value, 'setupIntegracao')}
                            value={services.mask.number(remuneracao.setupIntegracao) || ""}
                            helperText={isFormInvalid && !remuneracao?.setupIntegracao && 'Campo obrigatório'}
                            error={isFormInvalid && !remuneracao?.setupIntegracao ? true : false} />
                    </FormControl>
                </div>
                <div className='col-md-4 col-sm-4 col-lg-4'>
                    <FormControl >
                        <CurrencyTextField
                            f4ullWidth
                            id="standard-bare"
                            variant="outlined"
                            label="Comissão"
                            size="small"
                            currencySymbol="%"
                            decimalCharacter="."
                            onChange={(event, value) => changeRemueracaoObj(value, 'comissao')}
                            value={services.mask.number(remuneracao.comissao) || ""}
                            helperText={isFormInvalid && !remuneracao?.comissao && 'Campo obrigatório'}
                            error={isFormInvalid && !remuneracao?.comissao ? true : false} />
                    </FormControl>
                </div>
            </div>


            <div className='row mt20 ml-1'>
                <h1 className='label-second'>Dados Financeiros</h1>
            </div>
            {
                remuneracao?.dadosFinanceiros.map((_, index) => (
                    <div key={index}>
                        <DadosFinanceirosSeller
                            dadosFinanceiros={remuneracao?.dadosFinanceiros}
                            indexPosition={index}
                            setDadosBancarios={contaBancaria} />
                    </div>

                ))
            }
            <div className='row'>
                <div className='col-md-6 col-lg-6 col-sm-6'>
                    <strong onClick={adicionarConta} className='text-decoration'>+ ADICIONAR CONTA</strong>
                </div>
            </div>

            {/*             {idRemuneracaoSeller &&
                <div className="mt-5">
                    <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                        <button className="col-sm-6 col-md-6 col-lg-6 buton-green" onClick={() => submitRemuneracao()}>SALVAR</button>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                        <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border" onClick={() => subSellerPage(1)}>CANCELAR</button>
                        {remuneracao?.status != "Inativo" && <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border" onClick={inativarRemuneracao} >INATIVAR</button>}
                        {remuneracao?.status === "Inativo" && <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border" onClick={ativarRemuneracao}>ATIVAR</button>}
                    </div>


                </div>}
 */}

            <div className="mt-5">
                <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                    <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border" onClick={() => subSellerPage(1)}>CANCELAR</button>
                    <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-green" onClick={submitRemuneracao}>SALVAR</button>
                </div>

            </div>
        </div>
    )
}


export default RemuneracaoSeller;